import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@ui-nuvertos/shared';

@Injectable({
  providedIn: 'root'
})
export class AssetWriteOffService {
  private assetUrl = environment.assetUrl;

  constructor(private http: HttpClient) {}

  // ============================================
  // FORM TEMPLATE APIs
  // ============================================

  getFormTemplates(params?: any): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-write-off-form-templates/`;
    let httpParams = new HttpParams();
    if (params) {
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null) {
                httpParams = httpParams.append(key, params[key]);
            }
        });
    }
    return this.http.get<any>(url, { params: httpParams, withCredentials: true });
  }

  getFormTemplateById(id: string): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-write-off-form-templates/${id}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  // ============================================
  // ASSET WRITE-OFF CRUD APIs
  // ============================================

  createAssetWriteOff(data: any): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-write-offs/`;
    return this.http.post<any>(url, data, { withCredentials: true });
  }

  getAssetWriteOffs(params?: any): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-write-offs/`;
    let httpParams = new HttpParams();
    if (params) {
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null) {
                httpParams = httpParams.append(key, params[key]);
            }
        });
    }
    return this.http.get<any>(url, { params: httpParams, withCredentials: true });
  }

  getAssetWriteOff(id: string): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-write-offs/${id}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  updateAssetWriteOff(id: string, data: any): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-write-offs/${id}`;
    return this.http.put<any>(url, data, { withCredentials: true });
  }

  deleteAssetWriteOff(id: string): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-write-offs/${id}`;
    return this.http.delete<any>(url, { withCredentials: true });
  }
}
